module.exports = __webpack_public_path__ + "img/image.bb32342a.svg";